import { useState, useEffect } from 'react';

const useSVGScale = (initialScale: number, content: string) => {
  const [scaleValue, setScaleValue] = useState(initialScale);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      const svgElement = doc.querySelector('svg');

      const scaleFactorValue =
        svgElement?.getAttribute('data-svgscaling') ?? null;

      if (scaleFactorValue) {
        return setScaleValue(parseFloat(scaleFactorValue) * 100);
      }
      return setScaleValue(initialScale);
    } catch (error) {
      // eslint-disable-next-line
      console.error('Failed to parse SVG content:', error);
    }
  }, [content, initialScale, scaleValue]);
  return scaleValue;
};

export default useSVGScale;
